import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { Flex } from "antd"
import BookingTag from "../../../BookingTag"
import styles from "../../index.module.css"

// Tag colour per lifecycle status (falls back to green for booked/confirmed).
const STATUS_COLOR = {
  canceled: "error",
  requested: "warning",
  completed: "blue"
}

// An order (`orderNumber`) shows the order's number and no status of its own: each experience has
// its own, in its accordion.
const ReservationSummaryCard = ({ reservation, orderNumber = null }) => {
  const { t } = useTranslation()
  const isCanceled = reservation.rawStatus?.toLowerCase() === "canceled"
  const statusColor = STATUS_COLOR[reservation.rawStatus?.toLowerCase()] ?? "success"

  return (
    <div className={styles.card}>
      <Flex align="center" justify="space-between" gap={8} className={styles.cardHeader}>
        <span className={styles.cardTitle}>{t("booking.reservation_detail.summary_title")}</span>
        {!orderNumber && <BookingTag color={statusColor}>{reservation.status}</BookingTag>}
      </Flex>
      <div className={styles.summaryGrid}>
        <span className={styles.summaryKey}>{t("booking.reservation_detail.reservation_id")}</span>
        <span className={styles.summaryVal}>#{orderNumber ?? reservation.reservationNumber}</span>
        <span className={styles.summaryKey}>{t("booking.reservation_detail.source")}</span>
        <span className={styles.summaryVal}>{reservation.source}</span>
        <span className={styles.summaryKey}>{t("booking.reservation_detail.created")}</span>
        <span className={styles.summaryVal}>{reservation.created}</span>
      </div>
      {!orderNumber && isCanceled && reservation.cancellationReason && (
        <div className={styles.cancelReasonBox}>
          <span className={styles.cancelReasonLabel}>{t("booking.reservation_detail.cancellation_reason", "Cancellation reason")}</span>
          <span className={styles.cancelReasonText}>{reservation.cancellationReason}</span>
        </div>
      )}
    </div>
  )
}

ReservationSummaryCard.propTypes = {
  reservation: PropTypes.object.isRequired,
  orderNumber: PropTypes.string
}

export default ReservationSummaryCard
